// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editBottom[data-v-53b0114e] {\r\n  bottom: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
